export default __webpack_public_path__ + "static/media/plain-sticker-D.7ac4bb4c.png";